import lazyScreen from '../utils/lazyScreen';
const Employee = lazyScreen(() => import('../pages/hrm/Employee/index.js'), 'pages/hrm/Employee/index.js');
const Employees = lazyScreen(() => import('../pages/hrm/Employees/index.js'), 'pages/hrm/Employees/index.js');
const HRLeave = lazyScreen(() => import('../pages/hrm/HRLeave/index.js'), 'pages/hrm/HRLeave/index.js');
const HRLeaves = lazyScreen(() => import('../pages/hrm/HRLeaves/index.js'), 'pages/hrm/HRLeaves/index.js');
const HRAttendanceRequest = lazyScreen(() => import('../pages/hrm/HRAttendanceRequest/index.js'), 'pages/hrm/HRAttendanceRequest/index.js');
const HRAttendanceRequests = lazyScreen(() => import('../pages/hrm/HRAttendanceRequests/index.js'), 'pages/hrm/HRAttendanceRequests/index.js');

export default [
    {
        path: '/hrm/Employee/:code',
        component: Employee
    },
    {
        path: '/hrm/Employees',
        component: Employees
    },
    {
        path: '/hrm/HRLeave/:code',
        component: HRLeave
    },
    {
        path: '/hrm/HRLeaves',
        component: HRLeaves
    },
    {
        path: '/hrm/HRAttendanceRequest/:code',
        component: HRAttendanceRequest
    },
    {
        path: '/hrm/HRAttendanceRequests',
        component: HRAttendanceRequests
    }
];
